import React from 'react';
import Icon from '@material-ui/core/Icon';

export default function whichIcon(isTrue) {
  return isTrue ? <Icon>done</Icon> : <Icon>&nbsp;</Icon>;
}
